import * as React from 'react'
import { SVGProps } from 'react'

const SuccessIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx={12} cy={12} r={10} fill="#5FCD6B" />
    <path
      d="M18 8.841 9.771 16 6 12.719l.967-.841 2.804 2.434L17.033 8l.967.841Z"
      fill="#fff"
      stroke="#fff"
      strokeWidth={0.5}
    />
  </svg>
)

export default SuccessIcon
